import { useEffect, useState } from "react";
import FormLoading from "../../Components/FormLoading/FormLoading";
import IconButton from "../../Components/IconButton/IconButton";
import { useAppModalViewStore } from "../../Stores/AppModalView";
import { useConfigStore } from "../../Stores/Config";
import { ReactComponent as XIcon } from "../../Assets/x-mark.svg";
import "./AppModalView.scss";

function AppModalView() {
  const appModalViewStore = useAppModalViewStore();
  const configStore = useConfigStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (appModalViewStore.currentApp?.url) {
      setLoading(true);
    }
  }, [appModalViewStore.currentApp?.url]);

  if (!appModalViewStore.currentApp) {
    return null;
  }

  return (
    <div className="app-modal-view-main">
      <div className="widget-header">
        <div className="widget-header-sub">
          <div className="widget-header-sub-title widget-header-sub-title--no-back">
            {appModalViewStore.currentApp.name}
          </div>
          <IconButton
            icon={XIcon}
            ariaLabel={configStore.translateTextWithFallback("close", "Close")}
            onClick={() => {
              appModalViewStore.closeApp();
            }}
          />
          {loading && (
            <div className="app-modal-view-loader">
              <div className="app-modal-view-loader-inner"></div>
            </div>
          )}
        </div>
      </div>
      <div className={`app-modal-view ${loading && "app-modal-view--loading"}`}>
        {loading && <FormLoading />}
        <iframe
          allowFullScreen
          title={appModalViewStore.currentApp?.name || "App"}
          src={appModalViewStore.currentApp.url}
          frameBorder="0"
          sandbox="allow-scripts allow-forms allow-top-navigation allow-presentation allow-same-origin allow-popups"
          allow="autoplay; encrypted-media; fullscreen;"
          ref={(ref) => {
            // The booking listener only trusts this frame (isFromModalFrame).
            if (ref !== null && appModalViewStore.appFrame !== ref) {
              appModalViewStore.setAppFrame(ref);
            }
          }}
          onLoad={() => {
            setTimeout(() => {
              setLoading(false);
            }, 800);
          }}
        />
      </div>
    </div>
  );
}

export default AppModalView;
